import { FormattedMessage } from 'react-intl'

export function isStringOrFormattedMessage(value: React.ReactNode): boolean {
    if (typeof value === 'string') return true

    if (typeof value === 'object' && value !== null && 'type' in value) {
        return value.type === FormattedMessage
    }

    return false
}
